import React, { useMemo } from "react";

export const useTrigger = (
  trigger: JSX.Element,
  onClick: (event: React.MouseEvent) => void,
) =>
  useMemo(() => {
    // useTrigger needs to be able to attach an onClick handler to the passed-in
    // trigger. This is not possible with React fragments, since they don't
    // have DOM nodes to attach handlers to.
    if (Symbol.for("react.fragment") === trigger.type) {
      throw new Error(`React.Fragment triggers are not supported.`);
    }

    // Attach an onClick handler to the trigger component, but preserve user's
    // onClick handler, if they passed one in.
    return React.cloneElement(trigger, {
      ...trigger.props,
      onClick: (event: React.MouseEvent) => {
        onClick(event);
        if (typeof trigger.props.onClick === "function") {
          trigger.props.onClick(event);
        }
      },
    });
  }, [trigger, onClick]);
